import {type AppIsInactiveActions, SET_APP_IS_INACTIVE} from "./appIsInactiveActions";

import type {AppIsInactiveState} from "@atg-sport-shared/sportsbook-types-app-is-inactive";

export const initialState: AppIsInactiveState = {
    isInactive: false,
};

export const appIsInactiveReducer = (
    state: AppIsInactiveState = initialState,
    action: AppIsInactiveActions,
) => {
    switch (action.type) {
        case SET_APP_IS_INACTIVE: {
            const {payload} = action;

            return {
                ...state,
                isInactive: payload,
            };
        }
        default:
            return state;
    }
};
